/**
 * Other.js
 * purpose: contains some useful functions that don't belong in any specific category
 */

import { SpessaSynthCoreUtils } from "spessasynth_core";

const ConsoleColors = SpessaSynthCoreUtils.ConsoleColors;

export { ConsoleColors };
